import { mapState } from 'vuex';
import store from '@/store/store';

import ClientData from '@/components/clients/ClientData/ClientData.vue';
import OrdersList from '@/components/orders/OrdersList/OrdersList.vue';
import EmailModal from '@/components/ui/modals/EmailModal/EmailModal.vue';
import SmsModal from '@/components/ui/modals/SmsModal/SmsModal.vue';

export default {
  beforeRouteEnter(to, from, next) {
    const { clientId } = to.params;

    store.commit('startLoad');

    Promise.all([
      store.dispatch('clientInfo', clientId),
      store.dispatch('clientOrders', clientId)
    ]).then(() => {
      store.commit('endLoad');
      next();
    });
  },

  beforeRouteUpdate(to, from, next) {
    const { clientId } = to.params;

    this.$store.commit('startLoad');

    Promise.all([
      this.$store.dispatch('clientInfo', clientId),
      this.$store.dispatch('clientOrders', clientId)
    ]).then(() => {
      store.commit('endLoad');
      next();
    });
  },

  computed: {
    ...mapState({
      clients: state => state.clients.clients,
      orders: state => state.orders.orders,
      clientOrders: state => state.orders.clientOrders,
      clientInfo: state => state.clients.clientInfo,
      orderStatuses: state => state.user.orderStatuses,
      constructorNames: state =>
        state.user.constructors.map(constructor => constructor.name)
    })
  },

  methods: {
    openEmailModal() {
      this.$refs.emailModal.open(this.clientInfo.contact_email, '', '', {});
    },

    openSmsModal() {
      this.$refs.smsModal.open();
    },

    deleteClient() {
      const id = this.clientInfo.id;
      const deletePromise = this.$store.dispatch('clientDelete', id);

      deletePromise.then(
        () => {
          this.closeDeleteClientPopup();
          this.flashSuccess('Клиент удален');
          this.$router.push({ name: 'clients' });
        },
        error => {
          this.flashError('Не удалось сохранить данные о клиенте');
          console.error(error);
        }
      );
      return deletePromise;
    },

    openDeleteClientPopup() {
      this.$refs.clientDeleteAcceptModal.open();
    },

    closeDeleteClientPopup() {
      this.$refs.clientDeleteAcceptModal.close();
    }
  },

  components: {
    ClientData,
    OrdersList,
    EmailModal,
    SmsModal
  }
};
